/**
 * Static literal map of Vite-inlineable env accesses for the 15 non-secret keys.
 * Vite only inlines import.meta.env.X when X is a literal identifier — never a
 * computed key. The 4 secret keys (VITE_API_PRIVATE_KEY, VITE_API_PUBLIC_KEY,
 * VITE_DECRYPT_KEY, VITE_DECRYPT_IV) are intentionally excluded; they resolve
 * only from envs[backend] (the backend org-config fetch).
 */
export const viteEnvMap: Record<string, string | undefined> = {
  VITE_API: import.meta.env.VITE_API,
  VITE_ADMIN_API: import.meta.env.VITE_ADMIN_API,
  VITE_CLOUDINARY_CLOUD_NAME: import.meta.env.VITE_CLOUDINARY_CLOUD_NAME,
  VITE_CLOUDINARY_PRESET: import.meta.env.VITE_CLOUDINARY_PRESET,
  VITE_CLOUDINARY_UPLOAD_PRESET: import.meta.env.VITE_CLOUDINARY_UPLOAD_PRESET,
  VITE_CLOUDINARY_IMAGE_UPLOAD_PRESET: import.meta.env.VITE_CLOUDINARY_IMAGE_UPLOAD_PRESET,
  VITE_CLOUDINARY_VIDEO_UPLOAD_PRESET: import.meta.env.VITE_CLOUDINARY_VIDEO_UPLOAD_PRESET,
  VITE_ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT,
  VITE_GOOGLE_MAP_API: import.meta.env.VITE_GOOGLE_MAP_API,
  VITE_INTERCOM_APP_ID: import.meta.env.VITE_INTERCOM_APP_ID,
  VITE_EVENT: import.meta.env.VITE_EVENT,
  VITE_DOMAIN_NAME: import.meta.env.VITE_DOMAIN_NAME,
  VITE_API_SERVICE: import.meta.env.VITE_API_SERVICE,
  VITE_SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  VITE_SENTRY_ENVIRONMENT: import.meta.env.VITE_SENTRY_ENVIRONMENT,
};

export const envMapKeys = {
  api: { backend: "user_dashboard_api", frontend: "VITE_API" },
  admin_api :{
    backend:"admin_dashboard_api",
    frontend: "VITE_ADMIN_API"
  },
  api_private_key: {
    backend: "user_dashboard_api_private_key",
    frontend: "VITE_API_PRIVATE_KEY",
  },
  api_public_key: {
    backend: "user_dashboard_api_public_key",
    frontend: "VITE_API_PUBLIC_KEY",
  },
  cloudinary_cloud_name: {
    backend: "user_dashboard_cloudinary_cloud_name",
    frontend: "VITE_CLOUDINARY_CLOUD_NAME",
  },
  cloudinary_preset: {
    backend: "user_dashboard_cloudinary_preset",
    frontend: "VITE_CLOUDINARY_PRESET",
  },
  cloudinary_upload_preset: {
    backend: "user_dashboard_cloudinary_upload_preset",
    frontend: "VITE_CLOUDINARY_UPLOAD_PRESET",
  },
  cloudinary_image_upload_preset: {
    backend: "user_dashboard_cloudinary_image_upload_preset",
    frontend: "VITE_CLOUDINARY_IMAGE_UPLOAD_PRESET",
  },
  cloudinary_video_upload_preset: {
    backend: "user_dashboard_cloudinary_video_upload_preset",
    frontend: "VITE_CLOUDINARY_VIDEO_UPLOAD_PRESET",
  },
  decrypt_iv: {
    backend: "user_dashboard_decrypt_iv",
    frontend: "VITE_DECRYPT_IV",
  },
  decrypt_key: {
    backend: "user_dashboard_decrypt_key",
    frontend: "VITE_DECRYPT_KEY",
  },
  environment: {
    backend: "user_dashboard_environment",
    frontend: "VITE_ENVIRONMENT",
  },
  google_map_api: {
    backend: "user_dashboard_google_map_api",
    frontend: "VITE_GOOGLE_MAP_API",
  },
  intercom: {
    backend: "user_dashboard_intercom_app_id",
    frontend: "VITE_INTERCOM_APP_ID",
  },
  event: {
    backend: "user_dashboard_event",
    frontend: "VITE_EVENT",
  },
  domain_name: {
    backend: "user_dashboard_domain_name",
    frontend: "VITE_DOMAIN_NAME",
  },
  api_service: {
    backend: "user_dashboard_api_service",
    frontend: "VITE_API_SERVICE",
  },
  sentry_dsn: {
    backend: "user_dashboard_sentry_dsn",
    frontend: "VITE_SENTRY_DSN",
  },
  sentry_environment: {
    backend: "user_dashboard_environment",
    frontend: "VITE_SENTRY_ENVIRONMENT",
  },
} as const;
